<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Buffetvariationen</router-link>
      <router-link to="/speisen">Buffet ganz individuell </router-link>
      <router-link to="/getraenke">Getränke</router-link>
      <router-link to="/ausstattung">Zusatzausstattung</router-link>
      <router-link to="/angebot-fordern">Angebot anfordern</router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions(["fetchCateringItems", "fetchCategories"]),
  },
  mounted() {
    this.fetchCateringItems();
    this.fetchCategories();
  },
};
</script>

<style lang="scss">
#app {
  font-size: 18px;
}

#nav,
.next-back {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  a {
    font-weight: bold;
    color: #ececec;
    text-decoration: none;
    font-size: 18px;
    background-color: #7f9b5b;
    padding: 10px 20px;
    margin: 5px 0;
    width: 100%;
    &:hover {
      background-color: #586c3f;
    }
    &.router-link-exact-active {
      background-color: #586c3f;
    }
  }
}

.next-back {
  margin: 20px 0;
}

h2 {
  font-size: 36px;
}

h3 {
  font-size: 30px;
}

h4 {
  font-size: 26px;
}

@media screen and (min-width: 768px) {
  #nav,
  .next-back {
    a {
      width: auto;
    }
  }
}
</style>
